<template>
  <div>
    <my-menu menu-name="discovery"></my-menu>

    <my-footer></my-footer>
  </div>
</template>

<script>
  import MyFooter from '@/components/Footer'
  import MyMenu from '@/components/Menu'
  export default {
    data () {
      return {}
    },
    components: {
      MyFooter,
      MyMenu
    }
  }
</script>


// WEBPACK FOOTER //
// ListenDetail.vue?3e1bd5b9